import { createSlice } from '@reduxjs/toolkit'
import reducers from 'store/features/voiceCatalog/reducers'
import { getInitialState } from 'store/features/voiceCatalog/initialState'

const voiceCatalogSlice = createSlice({
  name: 'voiceCatalog',
  initialState: getInitialState(),
  reducers
})

export default voiceCatalogSlice
